import { Suspense, lazy, useEffect, useState } from 'react';

const Beams = lazy(() => import('./Beams.jsx'));

function HeroSection() {
	const showBeams = import.meta.env.MODE !== 'test';
	const [shouldLoadBeams, setShouldLoadBeams] = useState(false);
	const [allowVisualEffects, setAllowVisualEffects] = useState(false);
	const [isCompactViewport, setIsCompactViewport] = useState(false);

	useEffect(() => {
		if (!showBeams) return;

		const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
		const saveDataEnabled = window.navigator.connection?.saveData === true;
		const isSmallScreen = window.innerWidth < 1024;
		const isAllowed = !mediaQuery.matches && !saveDataEnabled;

		setIsCompactViewport(isSmallScreen);
		setAllowVisualEffects(isAllowed);
	}, [showBeams]);

	useEffect(() => {
		if (!showBeams || !allowVisualEffects) return;

		const scheduleLoad = () => setShouldLoadBeams(true);

		if ('requestIdleCallback' in window) {
			const idleId = window.requestIdleCallback(scheduleLoad, {
				timeout: 1500,
			});
			return () => window.cancelIdleCallback(idleId);
		}

		const timeoutId = window.setTimeout(scheduleLoad, 300);
		return () => window.clearTimeout(timeoutId);
	}, [showBeams, allowVisualEffects]);

	return (
		<section
			id='inicio'
			aria-labelledby='hero-title'
			className='relative min-h-[82svh] overflow-x-clip overflow-y-hidden border-b border-border-muted px-4 pb-10 pt-24 sm:min-h-[86svh] sm:px-6 sm:pb-12 sm:pt-28 md:min-h-screen lg:px-10 lg:pt-36'
		>
			<div className='pointer-events-none absolute inset-0 opacity-75'>
				{showBeams && allowVisualEffects && shouldLoadBeams ? (
					<Suspense fallback={null}>
						<Beams
							beamWidth={isCompactViewport ? 2 : 3}
							beamHeight={isCompactViewport ? 22 : 30}
							beamNumber={isCompactViewport ? 12 : 20}
							lightColor='#ffffff'
							speed={isCompactViewport ? 1.3 : 2}
							noiseIntensity={isCompactViewport ? 1.2 : 1.75}
							scale={isCompactViewport ? 0.16 : 0.2}
							rotation={isCompactViewport ? 24 : 30}
						/>
					</Suspense>
				) : null}
			</div>
			<div className='pointer-events-none absolute inset-0 bg-gradient-to-b from-black/20 via-black/55 to-black/90' />

			<div className='relative mx-auto grid min-h-[calc(82svh-7rem)] w-full max-w-[1400px] content-center gap-6 -translate-y-2 pt-2 sm:min-h-[calc(86svh-8rem)] md:min-h-[calc(100vh-9rem)] md:translate-y-0 md:gap-8 md:pt-0 lg:grid-cols-[minmax(0,1fr)_minmax(360px,0.55fr)] lg:items-center lg:gap-12'>
				<div className='max-w-[940px]'>
					<span className='mb-6 block font-display text-[11px] font-bold uppercase tracking-[0.4em] text-primary/40 sm:text-xs'>
						// DESARROLLO WEB Y SOFTWARE
					</span>
					<h1
						id='hero-title'
						className='title-readable font-display text-4xl font-bold uppercase leading-[0.92] text-primary sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl'
					>
						Web y software
						<br />
						a medida
						<br />
						para tu negocio
					</h1>
				</div>

				<p className='max-w-xl text-pretty text-base leading-relaxed text-primary/70 sm:text-lg lg:justify-self-end lg:border-l lg:border-border-muted lg:pl-8 lg:text-xl'>
					Creamos ecommerce y plataformas rápidas para ordenar tu operación,
					mejorar procesos y facilitar conversiones
				</p>
			</div>
		</section>
	);
}

export default HeroSection;
